module.exports = __webpack_public_path__ + "static/media/Dolores Kitchen Bookcases (5).2b23812e.jpg";